const SuffixMarker = {
    setSuffix(str) {
        return str + this.suffix;
    },
    hasSuffix(str) {
        return str.indexOf(this.suffix) !== -1;
    },
    pickMarkedBySuffix(arr) {
        return Object.values(arr).filter((item) => this.hasSuffix(item));
    },
};

export default SuffixMarker;
